export default {
  "vueform": {
    "elements": {
      "list": {
        "add": "+ Agregar",
        "remove": "&times;"
      },
      "file": {
        "defaultName": "Archivo",
        "dndTitle": "Cargar archivo.",
        "dndDescription": "Suelte el archivo o haga clic aquí para cargar.",
        "removeConfirm": "Al eliminar el archivo, este será eliminado permanentemente. ¿Está seguro que desea continuar?",
        "select": "Seleccione Archivo",
        "upload": "Cargar"
      },
      "multifile": {
        "uploadButton": "Cargar archivos",
        "dndTitle": "Cargar archivos",
        "dndDescription": "Suelte el archivo o haga clic aquí para cargar"
      },
      "gallery": {
        "uploadButton": "Cargar imágenes.",
        "dndTitle": "Cargar imágenes.",
        "dndDescription": "Suelte las imágenes o haga clic aquí para cargar."
      },
      "phone": {
        "ariaLabel": "Seleccione un país"
      },
      "signature": {
        "type": "Escribir",
        "draw": "Dibujar",
        "upload": "Subir",
        "font": "Seleccionar tipo de letra",
        "fontPlaceholder": "Tu nombre",
        "placeholder": "Firme aquí",
        "unsupportedFormat": "Formato de archivo no soportado. Las extensiones aceptadas son: :extensions",
        "maxSizeError": "El tamaño máximo del archivo es :max KB",
        "imgAlt": "Firma",
        "imgTitle": "Firma",
        "undo": "Deshacer",
        "redo": "Rehacer",
        "dnd": "Suelta una imagen aquí o",
        "uploadButton": "Seleccionar imagen",
        "modeSelectorAriaLabel": "Seleccionar modo de firma",
        "fontSelectorAriaLabel": "Seleccionar tipo de letra",
        "wrapperAriaLabel": "Campo de firma",
        "inputAriaLabel": "Escriba su firma aquí",
        "padAriaLabel": "Dibuje su firma en el recuadro. Pida ayuda si la necesita.",
        "clearAriaLabel": "Borrar firma",
        "colorAriaLabel": "Seleccionar color: "
      }
    },
    "steps": {
      "finish": "Terminar",
      "next": "Siguiente",
      "previous": "Previo"
    },
    "editor": {
      "acceptedMimesError": "Los mimos aceptados son: :mimes",
      "acceptedExtensionsError": "Las extensiones aceptadas son: :extensions"
    },
    "datepicker": {
      "weekdays": {
        "shorthand": [
          "Dom",
          "Lun",
          "Mar",
          "Mié",
          "Jue",
          "Vie",
          "Sáb"
        ],
        "longhand": [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado"
        ]
      },
      "months": {
        "shorthand": [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ],
        "longhand": [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ]
      },
      "daysInMonth": [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ],
      "firstDayOfWeek": 1,
      "ordinal": function () {
        return "º";
      },
      "rangeSeparator": " a ",
      "weekAbbreviation": "Wk",
      "scrollTitle": "Scroll to increment",
      "toggleTitle": "Click to toggle",
      "amPM": [
        "AM",
        "PM"
      ],
      "yearAriaLabel": "Year",
      "monthAriaLabel": "Month",
      "hourAriaLabel": "Hour",
      "minuteAriaLabel": "Minute"
    },
    "dateFormats": {
      "datetimeSeconds24": "DD/MM/YYYY HH:mm:ss",
      "datetimeSeconds12": "DD/MM/YYYY hh:mm:ss a",
      "datetime24": "DD/MM/YYYY HH:mm",
      "datetime12": "DD/MM/YYYY hh:mm a",
      "timeSeconds24": "HH:mm:ss",
      "timeSeconds12": "hh:mm:ss a",
      "time24": "HH:mm",
      "time12": "hh:mm a",
      "date": "DD/MM/YYYY"
    },
    "multiselect": {
      "multipleLabelOne": "1 opción seleccionada",
      "multipleLabelMore": ":options opciones seleccionadas",
      "noResults": "No se encuentran opciones",
      "noOptions": "La lista está vacía"
    },
    "defaultMessage": "Campo inválido",
    "a11y": {
      "file": {
        "description": "Press Backspace to remove"
      },
      "list": {
        "remove": "Remove item button"
      }
    },
    "countries": {
      "AF": "Afganistán",
      "AL": "Albania",
      "DZ": "Argelia",
      "AS": "Samoa Americana",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguila",
      "AG": "Antigua y Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Isla Ascensión",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaiyán",
      "BS": "Bahamas",
      "BH": "Baréin",
      "BD": "Bangladés",
      "BB": "Barbados",
      "BY": "Bielorrusia",
      "BE": "Bélgica",
      "BZ": "Belice",
      "BJ": "Benín",
      "BM": "Bermudas",
      "BT": "Bután",
      "BO": "Bolivia",
      "BA": "Bosnia y Herzegovina",
      "BW": "Botsuana",
      "BR": "Brasil",
      "IO": "Territorio Británico del Océano Índico",
      "VG": "Islas Vírgenes Británicas",
      "BN": "Brunéi",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Camboya",
      "CM": "Camerún",
      "CA": "Canadá",
      "CV": "Cabo Verde",
      "BQ": "Caribe Neerlandés",
      "KY": "Islas Caimán",
      "CF": "República Centroafricana",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CO": "Colombia",
      "KM": "Comoras",
      "CG": "Congo - Brazzaville",
      "CD": "Congo - Kinshasa",
      "CK": "Islas Cook",
      "CR": "Costa Rica",
      "CI": "Costa de Marfil",
      "HR": "Croacia",
      "CU": "Cuba",
      "CW": "Curazao",
      "CY": "Chipre",
      "CZ": "Chequia",
      "DK": "Dinamarca",
      "DJ": "Yibuti",
      "DM": "Dominica",
      "DO": "República Dominicana",
      "EC": "Ecuador",
      "EG": "Egipto",
      "SV": "El Salvador",
      "GQ": "Guinea Ecuatorial",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Esuatini",
      "ET": "Etiopía",
      "FK": "Islas Malvinas",
      "FO": "Islas Feroe",
      "FJ": "Fiyi",
      "FI": "Finlandia",
      "FR": "Francia",
      "GF": "Guayana Francesa",
      "PF": "Polinesia Francesa",
      "GA": "Gabón",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Alemania",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Grecia",
      "GL": "Groenlandia",
      "GD": "Granada",
      "GP": "Guadalupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GN": "Guinea",
      "GW": "Guinea-Bisáu",
      "GY": "Guyana",
      "HT": "Haití",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungría",
      "IS": "Islandia",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Irán",
      "IQ": "Irak",
      "IE": "Irlanda",
      "IL": "Israel",
      "IT": "Italia",
      "JM": "Jamaica",
      "JP": "Japón",
      "JO": "Jordania",
      "KZ": "Kazajistán",
      "KE": "Kenia",
      "KI": "Kiribati",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kirguistán",
      "LA": "Laos",
      "LV": "Letonia",
      "LB": "Líbano",
      "LS": "Lesoto",
      "LR": "Liberia",
      "LY": "Libia",
      "LI": "Liechtenstein",
      "LT": "Lituania",
      "LU": "Luxemburgo",
      "MO": "Macao",
      "MG": "Madagascar",
      "MW": "Malaui",
      "MY": "Malasia",
      "MV": "Maldivas",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Islas Marshall",
      "MQ": "Martinica",
      "MR": "Mauritania",
      "MU": "Mauricio",
      "MX": "México",
      "FM": "Micronesia",
      "MD": "Moldavia",
      "MC": "Mónaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marruecos",
      "MZ": "Mozambique",
      "MM": "Myanmar (Birmania)",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Países Bajos",
      "NC": "Nueva Caledonia",
      "NZ": "Nueva Zelanda",
      "NI": "Nicaragua",
      "NE": "Níger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Isla Norfolk",
      "KP": "Corea del Norte",
      "MK": "Macedonia del Norte",
      "MP": "Islas Marianas del Norte",
      "NO": "Noruega",
      "OM": "Omán",
      "PK": "Pakistán",
      "PW": "Palaos",
      "PS": "Palestina",
      "PA": "Panamá",
      "PG": "Papúa Nueva Guinea",
      "PY": "Paraguay",
      "PE": "Perú",
      "PH": "Filipinas",
      "PL": "Polonia",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Catar",
      "RE": "Reunión",
      "RO": "Rumanía",
      "RU": "Rusia",
      "RW": "Ruanda",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Santo Tomé y Príncipe",
      "SA": "Arabia Saudí",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leona",
      "SG": "Singapur",
      "SX": "Sint Maarten",
      "SK": "Eslovaquia",
      "SI": "Eslovenia",
      "SB": "Islas Salomón",
      "SO": "Somalia",
      "ZA": "Sudáfrica",
      "KR": "Corea del Sur",
      "SS": "Sudán del Sur",
      "ES": "España",
      "LK": "Sri Lanka",
      "BL": "San Bartolomé",
      "SH": "Santa Elena",
      "KN": "San Cristóbal y Nieves",
      "LC": "Santa Lucía",
      "MF": "San Martín",
      "PM": "San Pedro y Miquelón",
      "VC": "San Vicente y las Granadinas",
      "SD": "Sudán",
      "SR": "Surinam",
      "SE": "Suecia",
      "CH": "Suiza",
      "SY": "Siria",
      "TW": "Taiwán",
      "TJ": "Tayikistán",
      "TZ": "Tanzania",
      "TH": "Tailandia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad y Tobago",
      "TN": "Túnez",
      "TR": "Turquía",
      "TM": "Turkmenistán",
      "TC": "Islas Turcas y Caicos",
      "TV": "Tuvalu",
      "VI": "Islas Vírgenes de EE. UU.",
      "UG": "Uganda",
      "UA": "Ucrania",
      "AE": "Emiratos Árabes Unidos",
      "GB": "Reino Unido",
      "US": "Estados Unidos",
      "UY": "Uruguay",
      "UZ": "Uzbekistán",
      "VU": "Vanuatu",
      "VA": "Ciudad del Vaticano",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WF": "Wallis y Futuna",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabue"
    }
  },
  "validation": {
    "accepted": ":attribute debe ser aceptado.",
    "active_url": ":attribute no es una URL válida.",
    "after": ":attribute debe ser una fecha posterior a :date.",
    "after_or_equal": ":attribute debe ser una fecha posterior o igual a :date.",
    "alpha": ":attribute sólo debe contener letras.",
    "alpha_dash": ":attribute sólo debe contener letras, números, guiones y guiones bajos.",
    "alpha_num": ":attribute sólo debe contener letras y números.",
    "array": ":attribute debe ser un conjunto.",
    "before": ":attribute debe ser una fecha anterior a :date.",
    "before_or_equal": ":attribute debe ser una fecha anterior o igual a :date.",
    "between": {
      "numeric": ":attribute tiene que estar entre :min - :max.",
      "file": ":attribute debe pesar entre :min - :max kilobytes.",
      "string": ":attribute tiene que tener entre :min - :max caracteres.",
      "array": ":attribute tiene que tener entre :min - :max elementos."
    },
    "boolean": "El campo :attribute debe tener un valor verdadero o falso.",
    "captcha": "Please verify that you are not a robot.",
    "completed": "Please fill in a valid phone number.",
    "confirmed": "La confirmación de :attribute no coincide.",
    "date": ":attribute no es una fecha válida.",
    "date_format": ":attribute no corresponde al formato :format.",
    "date_equals": ":attribute debe ser una fecha igual a :date.",
    "different": ":attribute y :other deben ser diferentes.",
    "digits": ":attribute debe tener :digits dígitos.",
    "digits_between": ":attribute debe tener entre :min y :max dígitos.",
    "dimensions": "Las dimensiones de la imagen :attribute no son válidas.",
    "distinct": "El campo :attribute contiene un valor duplicado.",
    "email": ":attribute no es un correo válido.",
    "exists": "El :attribute seleccionado es inválido.",
    "file": "El campo :attribute debe ser un archivo.",
    "filled": "El campo :attribute es obligatorio.",
    "gt": {
      "numeric": "El campo :attribute debe ser mayor que :value.",
      "file": "El campo :attribute debe tener más de :value kilobytes.",
      "string": "El campo :attribute debe tener más de :value caracteres.",
      "array": "El campo :attribute debe tener más de :value elementos."
    },
    "gte": {
      "numeric": "El campo :attribute debe ser como mínimo :value.",
      "file": "El campo :attribute debe tener como mínimo :value kilobytes.",
      "string": "El campo :attribute debe tener como mínimo :value caracteres.",
      "array": "El campo :attribute debe tener como mínimo :value elementos."
    },
    "image": ":attribute debe ser una imagen.",
    "in": ":attribute es inválido.",
    "in_array": "El campo :attribute no existe en :other.",
    "integer": ":attribute debe ser un número entero.",
    "ip": ":attribute debe ser una dirección IP válida.",
    "ipv4": ":attribute debe ser una dirección IPv4 válida.",
    "ipv6": ":attribute debe ser una dirección IPv6 válida.",
    "json": "El campo :attribute debe ser una cadena JSON válida.",
    "lt": {
      "numeric": "El campo :attribute debe ser menor que :value.",
      "file": "El campo :attribute debe tener menos de :value kilobytes.",
      "string": "El campo :attribute debe tener menos de :value caracteres.",
      "array": "El campo :attribute debe tener menos de :value elementos."
    },
    "lte": {
      "numeric": "El campo :attribute debe ser como máximo :value.",
      "file": "El campo :attribute debe tener como máximo :value kilobytes.",
      "string": "El campo :attribute debe tener como máximo :value caracteres.",
      "array": "El campo :attribute debe tener como máximo :value elementos."
    },
    "max": {
      "numeric": ":attribute no debe ser mayor que :max.",
      "file": ":attribute no debe ser mayor que :max kilobytes.",
      "string": ":attribute no debe ser mayor que :max caracteres.",
      "array": ":attribute no debe tener más de :max elementos."
    },
    "mimes": ":attribute debe ser un archivo con formato: :values.",
    "mimetypes": ":attribute debe ser un archivo con formato: :values.",
    "min": {
      "numeric": "El tamaño de :attribute debe ser de al menos :min.",
      "file": "El tamaño de :attribute debe ser de al menos :min kilobytes.",
      "string": ":attribute debe contener al menos :min caracteres.",
      "array": ":attribute debe tener al menos :min elementos."
    },
    "not_in": ":attribute es inválido.",
    "not_regex": "El formato del campo :attribute no es válido.",
    "numeric": ":attribute debe ser numérico.",
    "present": "The :attribute field must be present.",
    "regex": "El formato de :attribute es inválido.",
    "required": "El campo :attribute es obligatorio.",
    "required_if": "The :attribute field is required when :other is :value.",
    "required_unless": "The :attribute field is required unless :other is in :values.",
    "required_with": "The :attribute field is required when :values is present.",
    "required_with_all": "The :attribute field is required when :values are present.",
    "required_without": "The :attribute field is required when :values is not present.",
    "required_without_all": "The :attribute field is required when none of :values are present.",
    "same": ":attribute y :other deben coincidir.",
    "size": {
      "numeric": "El tamaño de :attribute debe ser :size.",
      "file": "El tamaño de :attribute debe ser :size kilobytes.",
      "string": ":attribute debe contener :size caracteres.",
      "array": ":attribute debe contener :size elementos."
    },
    "string": "El campo :attribute debe ser una cadena de caracteres.",
    "timezone": ":attribute debe ser una zona horaria válida.",
    "unique": "El campo :attribute ya ha sido registrado.",
    "uploaded": "The :attribute failed to upload.",
    "url": ":attribute debe ser una URL válida.",
    "uuid": "El campo :attribute debe ser un UUID válido.",
    "remote": "The :attribute field is invalid."
  }
}